import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {CustomizeHttpUrlGenerator} from "../../../../store/core/url/customizeHttpUrlGenerator";
import {AbstractActionService} from "../../../core/service/v2/service/action/abstractAction.service";
import {SaleDeleteProductActionPayload} from "./payload/action/saleDeleteProductAction.payload";
import {PayloadWithId} from "../../../core/service/payload/payloadWithId";
import {SaleProductSummaryModel} from "../../modules/product/api/entity/saleProductSummary.model";
import {SaleProductSummaryConverter} from "../../modules/product/api/converter/saleProductSummary.converter";
import {ProductSummaryConverter} from "../../../product/api/entity/converter/productSummary.converter";
import {ProductSummaryModel} from "../../../product/api/entity/productSummary.model";

@Injectable()
export class SaleGetProductsDistinctActionService extends AbstractActionService<PayloadWithId, ProductSummaryModel[]> {

    public constructor(customizeHttpUrlGenerator: CustomizeHttpUrlGenerator,
                       httpClient: HttpClient,
                       private productSummaryConverter: ProductSummaryConverter) {
        super('Sale', 'get-products-distinct', customizeHttpUrlGenerator, httpClient);
    }

    protected buildResponse(response: any): ProductSummaryModel[] {
        return this.productSummaryConverter.convertFromArray(response);
    }
}